/*
 * Copyright 2024 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { MiddlewareFactory } from '@backstage/backend-defaults/rootHttpRouter';
import { mockServices } from '../services';

/**
 * A mock for error handler middleware that can be used in router tests.
 * @public
 *
 * @example
 * ```ts
 * const app = express();
 * app.use(mockErrorHandler());
 * ```
 */
export function mockErrorHandler(_options?: {}, ..._args: never[]) {
  return MiddlewareFactory.create({
    config: mockServices.rootConfig(),
    logger: mockServices.rootLogger(),
  }).error();
}
